import { gql, TypedDocumentNode } from '@common/hooks';
import {
  UpdateProfileStatusMutationMutationCgResponse,
  UpdateProfileStatusMutationMutationVariables,
} from '@common/graphql';

export const UPDATE_PROFILE_STATUS_MUTATION: TypedDocumentNode<
  UpdateProfileStatusMutationMutationCgResponse,
  UpdateProfileStatusMutationMutationVariables
> = gql`
  mutation UpdateProfileStatusMutation(
    $assignmentId: ID
    $applicationId: ID
    $identificationCode: String!
    $input: UpdateProfileStatusInput!
  ) {
    updateProfileStatus(
      applicationId: $applicationId
      assignmentId: $assignmentId
      identificationCode: $identificationCode
      input: $input
    ) {
      doNotRehire {
        id
        endsAt
        identificationCode
        institutionLevel
        reason
        archived
      }
      error {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;
